export const SelectActionTypes = {
  buttonClick: 'buttonClick',
  buttonArrowKeyDown: 'buttonArrowKeyDown'
};